import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { HttpService } from 'services/http.service';
import { OcrHiringSettingsModel } from 'services/models/hiring/ocr-hiring-settings.model';
import { Response } from 'services/models/response';
import { ServiceBase } from 'services/servicebase';

@Injectable()
export class OcrHiringSettingsService extends ServiceBase<OcrHiringSettingsModel> {
  constructor(http: HttpService) {
    super('hiringconfig/ocr-hiring-settings', http);
  }

  createEntity(input: any): OcrHiringSettingsModel {
    return OcrHiringSettingsModel.create(input);
  }

  getSetting(): Observable<Response<OcrHiringSettingsModel>> {
    return this.http.get(`${this.endpoint}`).pipe(
      map(res => {
        const response = new Response<OcrHiringSettingsModel>();
        response.data = this.createEntity(res.body || {}) as OcrHiringSettingsModel;
        return response;
      })
    );
  }

  public createOrUpdate(object: OcrHiringSettingsModel): Observable<any> {
    if (object.id && object.id !== '') {
      return this.http.put(this.endpoint, object);
    }

    return this.http.post(this.endpoint, object);
  }
}
